module.exports = __webpack_public_path__ + "videos/video-768@1x.0735719.mp4";